/**
 * Gestión de los documentos pdf subidos
 *
 * @link https://www.mendikat.net
 * @author Javi Urrutia <javi@mendikat.net>
 * @copyright 2023-2026 Mendikat
 * @license Mendikat
 *
 */

const { default: Axios } = require('axios');

const Documents =
    {
        data :
            {
                filebrowser:
                    {
                        // La instancia de editor de tinymce
                        editor : null,

                        // El filtro de documentos
                        filter : null,

                        // La lista de documentos pdf disponibles
                        documents : [],

                        // El documento seleccionado
                        document  : null,

                    },
            },
        methods : {
            /**
             * Carga la lista de documentos pdf subidos
             *
             * @param {Editor} editor       La instancia del editor (tinymce)
             *
             */
            loadFileBrowserDocuments: function (editor) {

                // Fija el editor (tinymce) con el que interactua el visor de documentos pdf
                this.filebrowser.editor = editor;

                // Resetea a cero el porcentaje de subida de un documento
                this.upload.progress = 0;

                // Obtiene el listado de documentos
                Axios.get(`/com/download/pdf/list/all`)
                    .then(response => {
                        this.filebrowser.documents = response.data;

                        // Abre la modal con la lista de documentos pdf subidos
                        this.$bvModal.show('modal-documents-browser');

                    })
                    .catch(error => {
                        console.error(error);
                    });
            },
            /**
             * Slecciona el documento e inserta una etiqueta en el editor activo
             *
             * @param {Document} document   El documento seleccionado
             */
            selectDocument: function (document) {

                // Inserta una etqieta {pdf}title|filename{/pdf}
                this.filebrowser.editor.insertContent(
                    `{pdf}Proporcione el título que desea que se muestre para el documento|${document.name}{/pdf}`
                );

                // Cerrar la modal con la lista de documentos pdf subidos
                this.$bvModal.hide('modal-documents-browser');
            },
            /**
             * Selecciona un nuevo documento pdf para subir
             *
             */
            selectDocumentForUpload: function () {
                // Abre el explorador de archivos para seleccionar el documento pdf a subir
                documentFile.click();
            },
            /**
             * Sube el nuevo documento pdf
             *
             * @param {Event} event
             *
             */
            uploadDocument: function (event) {

                let formData = new FormData();

                formData.append('document', event.target.files[0]);

                Axios.post(`/com/download/pdf/upload/document`,
                    formData,
                    {
                        headers:
                            {
                                'Content-Type': 'multipart/form-data',
                            },
                            onUploadProgress: function(progressEvent) {
                                this.upload.progress = parseInt( Math.round( ( progressEvent.loaded / progressEvent.total ) * 100 ));
                            }.bind(this)
                    },
                )
                .then(response => {

                    // Obtiene la información del documento
                    let document = response.data;

                    // Añade el documento a la lista
                    this.filebrowser.documents.unshift(document);

                   // Limpia el filtro
                   this.filebrowser.filter = null;

                    // Selecciona el documento subido
                    this.selectDocument(document);

                })
                .catch(error => {

                    this.upload.progress = 0;

                    // Abre la modal mostrando el error
                    this.$bvModal.show('document-not-valid');
                });
            },
            /**
             * Selecciona un nuevo documento pdf para subir
             *
             * @param {Document} document   El documento a eliminar
             *
             */
            confirmDeleteDocument: function (document) {
                // Selecciona el documento a eliminar
                this.filebrowser.document = document;

                // Abre la modal de confirmación de eliminación del documento
                this.$bvModal.show('modal-confirm-delete-document');
            },
            /**
             * Elimnina el documento pdf sleccionado
             *
             */
            deleteDocument: function () {

                // Obtiene el documento seleccionado
                const document = this.filebrowser.document;

                Axios.post(`/com/download/pdf/delete/document`,
                    {
                        document : document,
                    },
                )
                .then(() => {
                    // Suprime el documento del listado
                    this.filebrowser.documents = this.filebrowser.documents.filter(_document => document.name != _document.name);
                    // Limpia el filtro
                    this.filebrowser.filter = null;

                    // Ocultar la modal de confirmación de eliminación del documento
                    this.$bvModal.hide('modal-confirm-delete-document');

                })
                .catch(error => {
                    console.error(error);
                });
            },
        },
        computed : {
            /**
             * Obtiene los documentos filtrados en función del texto de búsqueda suministrado en el filtro
             *
             * @param {Event} event
             *
             * @returns {Document[]}         Una lista de documentos filtrados
             *
             */
            filteredDocuments: function () {
                if (!this.filebrowser.filter)  {
                    return this.filebrowser.documents;
                } else  {
                    return this.filebrowser.documents.filter(document => {
                        return document.name.toLowerCase().includes(this.filebrowser.filter.toLowerCase());
                    });
                }
            },
        }
    };

module.exports = Documents;